<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Preventie si stil de viata sanatos</li>
            </ul>
            <h2>Preventie si stil de viata sanatos</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3>Baza legala</h3>
                <ul>
                    <li>
                        <a href="https://viatacudiabet.ro/diabetul/ingrijirea-persoanei-cu-diabet" target="_blank">AFLA
                            MAI MULTE DESPRE VIATA CU DIABET</a>
                    </li>
                    <li>
                        <a href="https://www.cardioportal.ro/files/Program_de_Preventie_a_BCV.pdf?phpMyAdmin=LAPYS8VYVpMlZAH0k1mvv51DAQc" target="_blank">Program de preventie a bolilor cardiovasculare</a>
                    </li>
                    <li>
                        <a href="http://www.casan.ro/page/programul-national-de-oncologie.html" target="_blank">Program National de Sanatate pe oncologie</a>
                    </li>
                    <li>
                        <a href="http://www.aopsnaj.ro/?action=iPNS7" target="_blank">Program National de Santate pe ortopedie</a>
                    </li>
                    <li>
                        <a href="assets/img/limitareainfectiilor.docx" >Măsuri minime obligatorii pentru prevenirea şi limitarea infecţiilor</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

